import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SolutionCrystal } from "./SolutionCrystal";

const KEYS = ["core", "axis", "aip", "forge", "pulse"] as const;
const NAMES: Record<(typeof KEYS)[number], string> = {
  aip: "ARANON NAIP",
  forge: "ARANON FORGE",
  axis: "ARANON AXIS",
  pulse: "ARANON PULSE",
  core: "ARANON CORE",
};

export const Products = () => {
  const { t } = useTranslation();

  return (
    <section id="platforms" className="bg-background py-24 md:py-32">
      <div className="container-x">
        <div className="max-w-3xl mb-16">
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-6">
            {t("platforms.eyebrow")}
          </p>
          <h2 className="font-display text-4xl md:text-6xl font-light tracking-tight text-foreground">
            {t("platforms.title")}
          </h2>
          <p className="mt-8 text-base text-muted-foreground leading-relaxed">
            {t("platforms.intro")}
          </p>
        </div>

        <ul className="grid gap-4">
          {KEYS.map((k, idx) => {
            const tags = t(`platforms.tags.${k}`, { returnObjects: true }) as string[];
            return (
              <li key={k} className="group glass glass-shimmer rounded-2xl transition-all duration-500">
                <Link to={`/platforms/${k}`} className="grid md:grid-cols-12 gap-6 py-10 md:py-12 px-6 md:px-8 items-center">
                  <div className="md:col-span-2 flex items-center gap-3">
                    <SolutionCrystal variant={k} size="sm" />
                    <span className="text-xs text-muted-foreground tabular-nums">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <div className="md:col-span-4">
                    <h3 className="font-display text-3xl md:text-5xl font-light tracking-tight text-foreground">
                      {NAMES[k]}
                    </h3>
                    <p className="mt-3 text-xs uppercase tracking-[0.2em] text-muted-foreground">
                      {t(`platforms.items.${k}.role`)}
                    </p>
                  </div>
                  <div className="md:col-span-5">
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                      {t(`platforms.items.${k}.desc`)}
                    </p>
                    <div className="mt-5 flex flex-wrap gap-2">
                      {tags.map((tag) => (
                        <span
                          key={tag}
                          className="glass-pill text-[10px] uppercase tracking-[0.15em] text-muted-foreground rounded-full px-3 py-1"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <span className="md:col-span-1 text-foreground text-xl group-hover:translate-x-2 transition-transform justify-self-end self-start">
                    →
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
